import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from 'react-router';
import Timeline from './Timeline';
import "./HomeContentLayout.css";

const HomeLayout = () => {
  // react hooks
  const setPage = useNavigate();

  return(
    <div id="home-content-layout-wrapper">
      <Container fluid id="home-content-layout">
        <Row>
          <Col 
            id="home-content-main-text-wrapper"
            xs="auto" 
            sm="auto" 
            md="auto"
            lg={{span: 9, offset: 0}}
          >
            <div id="home-content-text-box">
              <span id="home-content-title">
                2022 Data Challenge Overview
              </span>
              <div id="home-content-text">
                <p>
                  Since 2016, the American Causal Inference Conference (ACIC) has hosted a data challenge in which teams 
                  compete to estimate causal impacts in simulated datasets based on real-world data from fields such as 
                  health care or education. The competition is a proving ground for cutting-edge causal inference methods 
                  that have the potential to transform program evaluation.
                </p>
                <p>
                  We hope that this year's competition will help us understand which methods give the most precise and nuanced 
                  estimates of policy impacts, ultimately enhancing the quality of evidence obtained from program evaluations 
                  seeking to improve public well-being.
                </p>
                <p>
                  We designed the datasets for the 2022 challenge to mirror data from evaluations of large-scale U.S. health 
                  care system interventions that aim to lower Medicare expenditures. They share features of these evaluations 
                  that challenge existing causal inference methods:
                </p>
                <ul>
                  <li>
                    Participation in the intervention is not randomly assigned, making it hard to tell whether the patients or 
                    practices that were motivated to join the intervention were already on a favorable trajectory or truly 
                    benefited from the program.
                  </li>
                  <li>
                    Impacts can be highly heterogenous, with the intervention potentially lowering expenditures for some patients 
                    while increasing expenditures for others.
                  </li>
                  <li>
                    The data have a hierarchical structure, with repeated observations of patients over time, and with patients 
                    clustered in primary care practices.
                  </li>
                  <li>
                    The outcome of interest, Medicare spending, is highly variable and skewed. The average patient incurs around 
                    $1,000 in costs per month, but some patients incur tens of thousands of dollars in costs.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col
            xs={{span: 12, offset: 0}}
            sm={{span: 12, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 3, offset: 0}}
          >
            <div className="button-card">
              <span className="button-card-title">
                Let's get started!
              </span>
              <Button onClick={() => setPage('/data')}>
                LEARN ABOUT <br /> THE DATA
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div id="comp-timeline-wrapper">
              <span>Competition Timeline</span>
              <div id="comp-timeline-box"> 
                <Timeline />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default HomeLayout;